import axios from "axios";
export default {
  data() {
    return {
      apiUrl: this.kpimEditorConfig.api,
      replacements: {
        "\\mu": "\\avg",
        Σ: "\\sum",
        "\\med": "\\median",
        Mo: "\\mode",
        "\\sigma": "\\stddev",
      },
      enableContinue: false,
    };
  },
  methods: {
    setEditableStep(step, value) {
      document.dispatchEvent(
        new CustomEvent("editable-steps", {
          detail: { step, value },
        }),
      );
    },
    //redirect to Kpis list
    routeToHome() {
      this.$router.push({
        path: "/kpis",
      });
      sessionStorage.removeItem("kpi");
    },

    routeToDashboard() {
      this.sessionItem.definition.targetValue = parseFloat(
        this.sessionItem.definition.targetValue,
      );
      let obj = this.sessionItem;
      obj.formula.expression = this.replaceValues(this.formula);
      this.sessionItem.formula.details.forEach((detail) => {
        // Trim spaces from the name
        let trimmedName = detail.name.replace(/\s+/g, "");

        // Replace the trimmed name in the expression with the original name
        obj.formula.expression = obj.formula.expression.replace(
          trimmedName,
          detail.name,
        );
      });
      sessionStorage.setItem("kpi", JSON.stringify(obj));
      this.setEditableStep("formula", 1);
      this.$router.push({
        path: "/editor/dashboard",
      });
    },

    //Change page to Definition
    routeToDefinition() {
      this.$router.push({
        path: "/editor/definition",
      });
    },

    //ingests the formula as it is written by the user and returns a string for BE calculation
    replaceValues(formula) {
      let resultString = formula;
      for (const [key, value] of Object.entries(this.replacements)) {
        resultString = resultString.split(key).join(value);
      }
      return resultString;
    },
    // Clears formula details, iterates over selected items,
    // and adds items whose names are found in the formula string.
    grabUsedMeasures() {
      this.sessionItem.formula.details.length = 0;
      this.sessionItem.definition.selected.forEach((item) => {
        if (
          this.formula
            .trim()
            .replace(/\s/g, "")
            .includes(item.name.trim().replace(/\s/g, ""))
        ) {
          this.sessionItem.formula.details.push(item);
        }
      });
    },

    getPreview(formula) {
      this.resultPreview = "";
      this.loading = true;
      this.grabUsedMeasures();
      if (this.sessionItem.formula.details.length === 0) {
        this.resultPreview = this.$t("errors.no-measures");
        this.loading = false;
        return;
      } else {
        let expression = this.replaceValues(formula);
        this.sessionItem.formula.details.forEach((detail) => {
          // Trim spaces from the name
          let trimmedName = detail.name.replace(/\s+/g, "");
          // Replace the trimmed name in the expression with the original name
          expression = expression.replaceAll(trimmedName, detail.name);
        });
        let body = {
          expression: expression,
          details: this.sessionItem.formula.details,
        };
        axios
          .post(`${this.apiUrl}/${this.realm}/formula/preview`, body, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.data.data.result) {
              this.resultPreview = response.data.data.result;
              //update the expression in the sessionStorage
              this.sessionItem.formula.expression = expression;
              this.enableContinue = true;
            }
          })
          .catch((err) => {
            this.setError(err, false);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //Called when the user types in the formula editor or when the formula changes
    //checks if formula still matches the stored sessionItem.formula.expression.
    //and it enables/disable the continue button by setting enableContinue to true/false.
    validateFormula(val) {
      if (this.sessionItem.formula.expression !== "") {
        if (
          this.sessionItem.formula.expression.trim().replace(/\s/g, "") ===
          val.trim().replace(/\s/g, "")
        ) {
          this.enableContinue = true;
        } else {
          this.enableContinue = false;
        }
      }
    },

    schedulePositiveNumber(value) {
      if (typeof value !== "string") {
        value = value.toString();
      }
      // Replace invalid characters with an empty string
      value = value.replace(/[^0-9]/g, "");
      // Ensure the value is not empty and is a positive integer
      if (!value || parseInt(value, 10) <= 0) {
        value = "0";
      }
      // Convert the final value to a number
      this.sessionItem.formula.job.schedule.value = parseInt(value, 10);
    },

    checkBalancedDelimiters(input) {
      // Regular expressions to match \left(, \right), \left[, \right], \left\{, and \right\}
      const leftParenPattern = /\\left\(/g;
      const rightParenPattern = /\\right\)/g;
      const leftSquarePattern = /\\left\[/g;
      const rightSquarePattern = /\\right\]/g;
      const leftCurlyPattern = /\\left\{/g;
      const rightCurlyPattern = /\\right\}/g;
      // Count the occurrences of each delimiter
      const leftParenCount = (input.match(leftParenPattern) || []).length;
      const rightParenCount = (input.match(rightParenPattern) || []).length;
      const leftSquareCount = (input.match(leftSquarePattern) || []).length;
      const rightSquareCount = (input.match(rightSquarePattern) || []).length;
      const leftCurlyCount = (input.match(leftCurlyPattern) || []).length;
      const rightCurlyCount = (input.match(rightCurlyPattern) || []).length;
      // Check if the counts of each type of delimiter are equal
      const parensBalanced = leftParenCount === rightParenCount;
      const squaresBalanced = leftSquareCount === rightSquareCount;
      const curliesBalanced = leftCurlyCount === rightCurlyCount;
      // Return true if all are balanced, false otherwise
      return parensBalanced && squaresBalanced && curliesBalanced;
    },
  },
};
